export enum EConceitoPrecificacao {
    Personalizada = 1,
    Clientes = 2,
    Representantes = 3,
    Vendedores = 4,
    RegiaoVenda = 5,
    FormaPagamento = 6
}
